import React from 'react';
import { Rocket, Settings, CheckCircle2 } from 'lucide-react';

const FutureProducts = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="py-16 px-4" style={{ background: 'var(--gradient-hero)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="heading-1 mb-6">Future Products</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Expanding our range to serve you better
          </p>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-page)' }}>
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6" style={{ color: 'var(--accent-text)' }}>
              <Rocket className="w-16 h-16" />
            </div>
            <h2 className="heading-2 mb-4">Innovation in Progress</h2>
            <p className="body-large" style={{ color: 'var(--text-body)' }}>
              At Seelakari Agro, we are constantly evolving to meet the changing needs of modern
              agriculture. We are actively working on expanding our product line to include more
              innovative irrigation and agricultural solutions.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="product-card text-center">
              <div className="flex justify-center mb-4" style={{ color: 'var(--accent-text)' }}>
                <Settings className="w-10 h-10" />
              </div>
              <h3 className="heading-3 mb-3">Advanced Systems</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Exploring smart irrigation systems with automation and remote monitoring
              </p>
            </div>

            <div className="product-card text-center">
              <div className="flex justify-center mb-4" style={{ color: 'var(--accent-text)' }}>
                <CheckCircle2 className="w-10 h-10" />
              </div>
              <h3 className="heading-3 mb-3">Quality Focus</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Researching new materials and technologies for better product performance
              </p>
            </div>

            <div className="product-card text-center">
              <div className="flex justify-center mb-4" style={{ color: 'var(--accent-text)' }}>
                <Rocket className="w-10 h-10" />
              </div>
              <h3 className="heading-3 mb-3">Farmer-Driven</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Listening to farmer feedback to develop products that truly meet their needs
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Placeholder for Future Products */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-section)' }}>
        <div className="max-w-6xl mx-auto">
          <h2 className="heading-2 mb-8 text-center">Products Under Development</h2>
          <div className="space-y-6">
            <div className="product-card">
              <h3 className="heading-3 mb-2" style={{ fontSize: '1.25rem' }}>
                Smart Irrigation Controllers
              </h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Automated irrigation management systems with mobile app control and weather-based
                scheduling for optimal water efficiency.
              </p>
              <div className="mt-4">
                <span className="inline-block px-3 py-1 rounded-full text-sm font-medium"
                  style={{ background: 'var(--accent-wash)', color: 'var(--accent-text)' }}>
                  Coming Soon
                </span>
              </div>
            </div>

            <div className="product-card">
              <h3 className="heading-3 mb-2" style={{ fontSize: '1.25rem' }}>
                Soil Moisture Sensors
              </h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Advanced sensors for real-time soil moisture monitoring to help farmers make
                data-driven irrigation decisions.
              </p>
              <div className="mt-4">
                <span className="inline-block px-3 py-1 rounded-full text-sm font-medium"
                  style={{ background: 'var(--accent-wash)', color: 'var(--accent-text)' }}>
                  Coming Soon
                </span>
              </div>
            </div>

            <div className="product-card">
              <h3 className="heading-3 mb-2" style={{ fontSize: '1.25rem' }}>
                Fertilizer Mixing Stations
              </h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Precision fertigation equipment for accurate mixing and delivery of nutrients
                through irrigation systems.
              </p>
              <div className="mt-4">
                <span className="inline-block px-3 py-1 rounded-full text-sm font-medium"
                  style={{ background: 'var(--accent-wash)', color: 'var(--accent-text)' }}>
                  Coming Soon
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stay Updated Section */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-page)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-2 mb-4">Stay Updated</h2>
          <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
            Want to be notified when we launch new products? Get in touch with us and we'll keep
            you informed about our latest offerings.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:6382799541" className="btn-primary">
              Call Us
            </a>
            <a href="mailto:seelakariymman@gmail.com" className="btn-secondary">
              Email Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FutureProducts;